// Agenda de visitas (AgendarForm, BookingModal, ManageAppointment, AppointmentsManagerModal, tokenAppointment, CalendarGrid) — Português (Brasil). Mismas claves que es/booking.ts.
export const bookingPt = {
  common: {
    branch: 'Loja',
    branchNumber: 'Loja #{{id}}',
    viewMyAppointments: 'Ver meus agendamentos',
    edit: 'Editar',
    yourData: 'Seus dados',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Celular',
    firstNamePlaceholder: 'João',
    lastNamePlaceholder: 'Silva',
    emailPlaceholder: 'seuemail@exemplo.com',
    phonePlaceholder: '+55 11 91234-5678',
    saveMyData: 'Salvar meus dados',
    noteOptional: 'Observação (opcional)',
    notePlaceholder: 'Ex.: Vou com acompanhante, quero ver o porta-malas etc.',
    selectBranchAria: 'Selecionar loja',
    selectBranchPlaceholder: 'Selecione uma loja',
    grayDaysHint: 'Os dias em cinza aparecem para manter a visão do calendário, mas não têm horários.',
    slotsFor: 'Horários para {{date}}',
    noSlots: 'Não há horários disponíveis nesta data. Tente outro dia.',
    visitReason: 'Motivo da sua visita',
    bookVisit: 'Agendar visita',
    bookAnother: 'Agendar outra visita',
    cancelAppointment: 'Cancelar agendamento',
    close: 'Fechar',
    back: 'Voltar',
  },
  reasons: {
    verVehiculo: 'Ver um veículo',
    tasarAuto: 'Avaliar meu carro',
    financiamiento: 'Financiamento',
    otraConsulta: 'Outro assunto',
    consignarAuto: 'Consignar meu carro',
    venderAuto: 'Vender meu carro',
    visitaShowroom: 'visita ao showroom',
    visita: 'visita',
  },
  toast: {
    slotsLoadError: 'Erro ao carregar horários: {{error}}',
    missingClientId: 'Falta client_id',
    completeData: 'Preencha seus dados corretamente',
    dataSaved: 'Dados salvos',
    dataSaveFailed: 'Não foi possível salvar seus dados',
    completeToContinue: 'Preencha seus dados para continuar.',
    completeAndSaveToContinue: 'Preencha e salve seus dados para continuar.',
    emailFailed: 'Visita agendada, mas não conseguimos enviar a confirmação para o seu e-mail.',
    slotTaken: 'Esse horário acabou de ser reservado. Escolha outro.',
    alreadyBooked: 'Você já tem um agendamento nesse horário.',
    tooMany: 'Você já atingiu o máximo de agendamentos ativos. Cancele um para agendar outro.',
    slotUnavailable: 'Esse horário não está mais disponível. Escolha outro.',
    createFailed: 'Não foi possível criar o agendamento: {{code}}',
    booked: 'Visita agendada com sucesso!',
    requested: 'Solicitação enviada. A loja vai confirmar sua visita.',
  },
  email: {
    confirmSubject: 'Confirmação de agendamento: {{reason}}',
    newSubject: 'Novo agendamento: {{reason}}',
    confirmSubjectVehicle: 'Confirmação de Agendamento: {{vehicle}}',
    newSubjectVehicle: 'Novo Agendamento: {{vehicle}}',
    requestSubject: 'Recebemos sua solicitação de visita: {{reason}}',
    newPendingSubject: 'Nova visita PARA ACEITAR: {{reason}}',
    requestSubjectVehicle: 'Recebemos sua solicitação de visita: {{vehicle}}',
    newPendingSubjectVehicle: 'Nova visita PARA ACEITAR: {{vehicle}}',
    sellerSubject: 'Novo Agendamento para o seu veículo: {{brand}} {{model}}',
    cancelledSubject: 'Agendamento Cancelado: {{brand}} {{model}}',
    cancelledSellerSubject: 'Agendamento Cancelado para o seu veículo: {{brand}} {{model}}',
    customerFallback: 'Cliente',
  },
  calendar: {
    prevMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
    noSlots: 'Sem horários disponíveis',
    loadingMonth: 'Carregando a disponibilidade do mês…',
    wd0: 'D',
    wd1: 'S',
    wd2: 'T',
    wd3: 'Q',
    wd4: 'Q',
    wd5: 'S',
    wd6: 'S',
  },
  form: {
    title: 'Agende sua visita',
    subtitleBefore: 'Reserve um horário com ',
    subtitleAfter: ' e esperamos por você.',
    subtitleFallbackName: 'a nossa equipe',
    stepDayTime: 'Dia e horário',
    stepReasonData: 'Motivo e dados',
    stepConfirm: 'Confirmar',
    done: 'Tudo certo!',
    expectOn: 'Esperamos você no dia ',
    doneRequested: 'Solicitação enviada!',
    requestedOn: 'Você pediu o dia ',
    requestedNote: 'Vamos confirmar assim que revisarmos. O horário fica reservado até então.',
    expectAt: ' às ',
    expectIn: ' em',
    reasonPrefix: 'Motivo: ',
    loadingBranches: 'Carregando lojas…',
    chooseDay: 'Escolha um dia',
    chooseSlot: 'Escolha um horário',
    pickDateFirst: 'Primeiro escolha uma data no calendário.',
    reviewConfirm: 'Revise e confirme',
    summaryDay: 'Dia',
    summaryTime: 'Horário',
    summaryReason: 'Motivo',
    summaryName: 'Em nome de',
    summaryNote: 'Observação',
    back: 'Voltar',
    continue: 'Continuar',
  },
  modal: {
    selectBranch: 'Selecione a loja',
    timezone: 'Fuso horário: ',
    stepDate: 'Data',
    stepTime: 'Horário',
    manageTooltip: 'Veja e gerencie seus agendamentos',
    selectDate: 'Selecione uma data',
    pickDateFirst: 'Primeiro escolha uma data.',
    summary: 'Resumo',
    chooseDate: 'Escolher data',
    chooseTime: 'Escolher horário',
    confirm: 'Confirmar agendamento',
  },
  manager: {
    title: 'Meus agendamentos',
    fetchFailed: 'Não foi possível carregar os agendamentos',
    pastCannotCancel: 'Não é possível cancelar um agendamento que já passou.',
    notFound: 'Agendamento não encontrado',
    cancelFailedMaybe: 'Não foi possível cancelar o agendamento (talvez já tenha passado ou já esteja cancelado).',
    cancelled: 'Agendamento cancelado',
    cancelFailed: 'Não foi possível cancelar o agendamento',
    empty: 'Você não tem agendamentos próximos.',
    note: 'Observação:',
    rescheduleHelp: 'Para remarcar, cancele e agende novamente.',
    help: 'Ajuda',
    confirmTitle: 'Confirmar cancelamento',
    confirmText: 'Deseja cancelar este agendamento? Você pode informar um motivo (opcional).',
    reasonPlaceholder: 'Ex.: Não vou poder comparecer, preciso remarcar etc.',
    statusPending: 'Pendente',
    statusConfirmed: 'Confirmado',
  },
  manage: {
    title: 'Gerenciar minha visita',
    notFoundHint: 'Se você agendou há pouco, confira o link da mensagem que recebeu.',
    cancelledTitle: 'Sua visita foi cancelada.',
    cancelledText: 'Se quiser vir outro dia, pode agendar novamente quando quiser.',
    rescheduledTitle: 'Sua visita foi remarcada.',
    rescheduledText: 'Esperamos você no novo horário.',
    date: 'Data',
    time: 'Horário',
    reason: 'Motivo',
    viewDetail: 'Ver os detalhes da minha visita',
    stepConfirm: 'Confirmar',
    whichDay: 'Qual dia é melhor para você?',
    whichTime: 'Qual horário?',
    noSlotsLeft: 'Não há mais horários neste dia. Tente outro.',
    confirmChange: 'Confirme a alteração',
    newDate: 'Nova data',
    newTime: 'Novo horário',
    keepsNote: 'A loja e o motivo continuam os mesmos. Seu horário anterior fica liberado.',
    confirmNewSlot: 'Confirmar novo horário',
    wasRescheduled: 'Esta visita foi remarcada.',
    leftForOn: 'Sua visita ficou para ',
    leftForAt: ' às ',
    viewNewVisit: 'Ver minha nova visita',
    cancelledState: 'Esta visita está cancelada. Se quiser vir outro dia, pode agendar novamente.',
    doneState: 'Esta visita já foi realizada. Obrigado pela visita!',
    tooSoon: 'Falta muito pouco para a sua visita. Se não puder vir, ligue para a loja.',
    reschedule: 'Remarcar',
    confirmCancelQuestion: 'Deseja cancelar sua visita?',
    confirmCancelText: 'Você vai perder o horário. Pode agendar outro depois.',
    yesCancel: 'Sim, cancelar',
    noBack: 'Não, voltar',
  },
  page: {
    unavailableTitle: 'Agenda indisponível',
    unavailableText: 'Não conseguimos identificar a concessionária. Verifique o link e tente novamente.',
  },
};
